import React from 'react';
import '../styles/pages/Home.css';

const Home = () => {
  return (
    <div className="home-page-artistic">
      {/* Background Circles (Thin outlines) */}
      <div className="bg-circle circle-1"></div>
      <div className="bg-circle circle-2"></div>

      {/* Social Sidebar */}
      <div className="social-sidebar">
        <a href="https://github.com/ikehvictor" target="_blank" rel="noreferrer"><i className="fab fa-github"></i></a>
        <a href="https://linkedin.com/in/ikehvictor" target="_blank" rel="noreferrer"><i className="fab fa-linkedin-in"></i></a>
        <a href="https://wa.me/" target="_blank" rel="noreferrer"><i className="fab fa-whatsapp"></i></a>
      </div>

      {/* Hero Section */}
      <section className="hero-artistic">
        <div className="hero-center-content">
          <div className="image-frame-container">
            {/* The Gradient Background Shape (Arch) */}
            <div className="hero-background-shape"></div>
            
            {/* The Green Scribble/Coil SVG - BEHIND Segment */}
            {/* The Green Scribble/Coil SVG - BEHIND Layer */}
            <svg className="green-swirl swirl-behind" viewBox="0 0 700 800" xmlns="http://www.w3.org/2000/svg" overflow="visible">
              
              {/* Segment 4: Behind 2 */}
              <path 
                d="M 580,565 C 630,560 630,480 350,480 C 70,480 70,510 120,505" 
                fill="none" stroke="#3fb18c" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"
                className="coil-path coil-4"
              />
              {/* Segment 6: Behind 3 */}
              <path 
                d="M 580,445 C 630,440 630,360 350,360 C 70,360 70,390 120,385" 
                fill="none" stroke="#3fb18c" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"
                className="coil-path coil-6"
              />
            </svg>

            {/* The Portrait Image */}
            <img src="/images/img.png" alt="Ikeh Victor" className="hero-portrait" />
            
            {/* The Green Scribble/Coil SVG - FRONT Layer */}
            <svg className="green-swirl swirl-front" viewBox="0 0 700 800" xmlns="http://www.w3.org/2000/svg" overflow="visible">
              <defs>
                <path id="textCirclePath" d="M 620,142 a 38,38 0 1,1 -0.1,0" />
              </defs>
              
             
              {/* Segment 3: Front Belly */}
              <path 
                d="M 120,625 C 170,620 530,570 580,565" 
                fill="none" stroke="#3fb18c" strokeWidth="2.8" strokeLinecap="round" strokeLinejoin="round"
                className="coil-path coil-3"
              />
              {/* Segment 5: Front Chest */}
              <path 
                d="M 120,505 C 170,500 530,450 580,445" 
                fill="none" stroke="#3fb18c" strokeWidth="2.8" strokeLinecap="round" strokeLinejoin="round"
                className="coil-path coil-5"
              />
              {/* Segment 7: Front Top to Circle */}
              <path 
                d="M 120,385 C 220,375 500,320 620,180" 
                fill="none" stroke="#3fb18c" strokeWidth="2.8" strokeLinecap="round" strokeLinejoin="round"
                className="coil-path coil-7"
              />
              
              {/* The "Call to Action" Circle */}
              <g transform="translate(620, 180)">
                <circle cx="0" cy="0" r="28" fill="white" stroke="#dcece5" strokeWidth="14" />
                <circle cx="0" cy="0" r="28" fill="none" stroke="#3fb18c" strokeWidth="1.5" />
              </g>

              {/* Curved Text wrapping around the circle */}
              <text className="swirl-text-path" fontSize="11" fontWeight="600" letterSpacing="1.5">
                <textPath xlinkHref="#textCirclePath" startOffset="50%" textAnchor="middle">
                  COME ON LET'S TALK
                </textPath>
              </text>
            </svg>
          </div>

          <div className="hero-text-content">
            <h1 className="hero-name">Ikeh Victor</h1>
            <p className="hero-title-artistic">FULL-STACK ENGINEER & AI AUTOMATION SPECIALIST</p>
          </div>
        </div>
      </section>

    </div>
  );
};

export default Home;